<template>
    <div class="row mb-3">
        <div class="col-sm-12 col-md-12">
            <ul class="warranty-submenu">
                <li>
                    <router-link :to="{name: 'SuperadminRegisteredProductsRequestRepair'}">
                        Repair Requests
                    </router-link>
                </li>

                <li>
                    <router-link :to="{name: 'SuperadminRegisteredProductsActiveRepair'}">
                        Active Repairs
                    </router-link>
                </li>

                <li>
                    <router-link :to="{name: 'SuperadminRegisteredProductsClosedRepair'}">
                        Closed Repairs
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RepairSubNav',
    components: {},
    data() {
        return {};
    }
};
</script>
